var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "apps-integration" } },
    [
      _c(
        "or-button",
        {
          attrs: {
            "data-button": "open-apps-integration-options",
            loading: _vm.isInitializing,
            disabled: _vm.isInitializing,
          },
          on: { click: _vm.onOpenPopup },
        },
        [
          _c("or-icon", { attrs: { icon: _vm.icon } }),
          _vm._v("\n    " + _vm._s(_vm.openButtonLabel) + "\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _c("or-modal", {
        attrs: { "data-popup": "apps-integration", "is-open": _vm.isPopupOpen },
        on: {
          close: function ($event) {
            _vm.isPopupOpen = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "HITL.app-launcher.apps-integration.apps-options-title"
                      )
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "default",
            fn: function () {
              return [
                _vm.content === "preview"
                  ? _c("apps-integration-preview", {
                      attrs: { app: _vm.app, "qr-code-url": _vm.qrCodeUrl },
                      on: {
                        "qr-code-click": function ($event) {
                          return _vm.$emit("qr-code-click")
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.content === "update"
                  ? _c("apps-integration-options", {
                      ref: "apps-integration-options",
                      attrs: {
                        app: _vm.app,
                        account: _vm.account,
                        env: _vm.env,
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _vm.optionsType === "update"
                      ? _c(
                          "or-button",
                          {
                            attrs: {
                              color: _vm.activateButtonColor,
                              disabled: _vm.isUpdating,
                              loading: _vm.isActivating,
                            },
                            on: { click: _vm.onToggleActivate },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.activateButtonLabel) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "actions-block" },
                      [
                        _c(
                          "or-button",
                          {
                            attrs: {
                              color: "primary",
                              variant: "outlined",
                              disabled: _vm.isUpdating || _vm.isActivating,
                            },
                            on: { click: _vm.onCancel },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("HITL.common.actions.cancel")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "or-button",
                          {
                            attrs: {
                              color: "primary",
                              loading: _vm.isUpdating,
                              disabled:
                                !_vm.isSuccessButtonEnabled || _vm.isActivating,
                            },
                            on: { click: _vm.onSuccess },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.successButtonLabel) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }